import mod from "-!./user.js?vue&type=script&lang=js&"; export default mod; export * from "-!./user.js?vue&type=script&lang=js&"